import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/recruitment-management-systems/interview-management/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "interview-management" entry is kept); the seo block below is a fallback.

export const interviewManagement: ContentPage = {
  slug: "recruitment-management-systems/interview-management",
  template: "hrmsFeature",
  seo: {
    title: "Efficient Interview Management for Recruiters",
    description: "Streamline recruitment with our interview management system, featuring automated scheduling, interviewer resources, and centralized feedback for efficiency.",
    keywords: [
      "interview management",
      "automated scheduling",
      "recruitment process optimization",
      "interviewer toolkit",
      "feedback collection system.",
    ],
    ogImage: "/assets/data/seoimages/interview-management.webp",
  },
  leaf: {
    hero: {
      caption: "Interview Management",
      title: "Streamline Your Interview Scheduling and Management",
      description: "Coordinate and manage candidate interviews efficiently with our comprehensive interview management system, optimizing your recruitment process.",
      h1: "caption",
    },
    split: {
      title: "Efficient Interview Coordination",
      bullets: [
        { title: "Automated Interview Scheduling", description: "Coordinate interviews based on availability seamlessly." },
        { title: "Interviewer Toolkit", description: "Provide resources and guidelines for effective interviews." },
        { title: "Centralized Feedback Collection", description: "Gather and streamline interview feedback in one place." },
        { title: "Conflict-Free Calendar Syncing", description: "Sync with calendars to avoid scheduling conflicts." },
      ],
      image: "/assets/images/img/product/hrms/recruitmentms/interview-management_info.webp",
      imageAlt: "interview-management_info",
    },
    cardsHeading: {
      title: "Key Features of Recruitment Management System",
      description: "Optimize Recruitment Management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Multi-Platform Job Posting",
        href: "/hrms-software/recruitment-management-systems/multi-platform-job-posting/",
        description: "Expand your talent search by posting jobs simultaneously across multiple job boards and social media platforms with a single click.",
        image: "/assets/images/img/product/hrms/recruitmentms/multi-platform-job-posting.webp",
        imageAlt: "multi-platform-job-posting",
      },
      {
        title: "Candidate Communication",
        href: "/hrms-software/recruitment-management-systems/candidate-communication/",
        description: "Keep candidates informed and engaged throughout the recruitment process with automated, personalized communication tools.",
        image: "/assets/images/img/product/hrms/recruitmentms/candidate-communication_image.webp",
        imageAlt: "candidate-communication",
      },
      {
        title: "Resume Parsing",
        href: "/hrms-software/recruitment-management-systems/resume-parsing/",
        description: "Extract and analyze candidate information efficiently with our AI-driven resume parsing technology, speeding up the recruitment process.",
        image: "/assets/images/img/product/hrms/recruitmentms/resume-parsing.webp",
        imageAlt: "resume-parsing",
      },
      {
        title: "Reporting and Analytics",
        href: "/hrms-software/recruitment-management-systems/reporting-and-analytics/",
        description: "Utilize powerful analytics and customized reports to gain insights into your recruitment process, improving decision-making and strategy.",
        image: "/assets/images/img/product/hrms/recruitmentms/reporting-and-analytics_img.webp",
        imageAlt: "reporting-and-analytics",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Optimize Your Interview Processes Today!",
    relatedBlogsKeyword: "hrms-interview-management,reducing-time-to-hire,hr-tech-trends-recruitment",
    metaKey: "interview-management",
  },
  sections: [],
};
